/* eslint-disable import/prefer-default-export */

'use server';

import { cookies } from 'next/headers';
import { getIronSession } from 'iron-session';
import fetchJson from '~/utils/Fetch/json';
import API from '~/config/api';
import { sessionOptions } from '~/config/session';
import { getCRMRedirectUrl } from '~/utils/authServer';

export async function signin(prevState, formData) {
  const email = formData.get('email');
  const password = formData.get('password');
  const rememberMe = formData.get('remember-me') === 'on';
  const prevUrl = formData.get('prevUrl');

  const errors = {};
  if (!email) errors.email = 'Email is required.';
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) errors.email = 'Please enter a valid email address.';
  if (!password) errors.password = 'Password is required.';

  if (Object.keys(errors).length > 0) {
    return {
      message: 'Please fill in all required fields.',
      alert: 'error',
      errors,
      formData: {},
    };
  }

  try {
    const { data, headers } = await fetchJson(
      API.Auth.login({}),
      API.POST_CONFIG({ data: { login: email, password } }),
    );

    const auth = {
      uuid: headers.get('uuid'),
      client: headers.get('client'),
      accessToken: headers.get('access-token'),
      expiry: headers.get('expiry'),
    };

    const maxAge = rememberMe ? 30 * 24 * 60 * 60 : undefined;
    const cookieStore = await cookies();
    const session = await getIronSession(cookieStore, {
      ...sessionOptions,
      cookieOptions: {
        ...sessionOptions.cookieOptions,
        ...(maxAge ? { maxAge } : {}),
      },
    });

    session.user = { ...data.data };
    session.auth = auth;
    session.persistent = rememberMe;
    await session.save();

    let redirectUrl;
    if (prevUrl) {
      const origin = process.env.CLIENT_ORIGIN || 'https://www.realestateagents.com';
      try {
        const decoded = decodeURIComponent(prevUrl);
        const candidate = new URL(decoded, origin);
        const allowedHost = new URL(origin).host;
        redirectUrl = candidate.host === allowedHost
          ? candidate.href : await getCRMRedirectUrl(auth);
      } catch {
        redirectUrl = await getCRMRedirectUrl(auth);
      }
    } else {
      redirectUrl = await getCRMRedirectUrl(auth);
    }

    return {
      message: '',
      alert: 'success',
      redirectUrl,
      errors: {},
      formData: {},
    };
  } catch (e) {
    if (e?.response?.status === 401) {
      return {
        message: 'The email address or password you entered is incorrect.',
        alert: 'error',
        errors: {},
        formData: {},
      };
    }
    return {
      message: 'Unexpected error occurred. Please try again later.',
      alert: 'error',
      errors: {},
      formData: {},
    };
  }
}
